import React from 'react'
import '../Services_details.css';

export default function Services_Portfolio() {

    const Features1 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Hosting (FREE)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Mobile Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Social Media Integrations</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Lead Generation / Contact Form</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Single Page</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>CSS Animations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Post Project Support</h3>
                    </div>
                </div>
            </div>
        );
    };

    const Features2 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Hosting (FREE)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Mobile Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Social Media Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Lead Generation / Contact Form</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>2 - 6 Pages</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>CSS Animations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="content-box">
            <h3 className="heading-main">Portfolio Design</h3>
            <p>
                We offer exceptional portfolio design services to help you showcase your work in the most professional and appealing way. Our designs are crafted to highlight your skills, projects, and achievements effectively.
                <ul>
                    <li><strong>Custom Design</strong>: Tailored to reflect your personal brand and style.</li>
                    <li><strong>Responsive Layouts</strong>: Ensuring your portfolio looks great on all devices.</li>
                    <li><strong>Interactive Elements</strong>: Adding dynamic features to engage your audience.</li>
                </ul>
            </p>

            <div className='packages'>
                <h2 className="heading">Packages</h2>
                <div className="packages-container">
                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Basic</h3>
                            <h4>Portfolio Design Package</h4>
                        </div>
                        <p>The Basic Portfolio Package is ideal for individuals who are just beginning their professional journey. This package provides a sleek, professionally designed portfolio to showcase your skills and projects, ensuring you make a strong first impression.
                        </p>

                        <Features1 />

                        <h4 className='cost'><strong>Cost: </strong>₹1,000 - ₹6,000</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Basic%20Package%20for%20Portfolio%20Design'
                            className='btn2'>
                            Contact for OFFERS
                        </a>

                    </div>

                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Pro</h3>
                            <h4>Portfolio Design Package</h4>
                        </div>
                        <p>The Pro Package is perfect for those looking to elevate their professional presence. With advanced design features, personalized branding, and interactive elements, this package helps you stand out and effectively highlight your expertise and achievements.</p>

                        <Features2 />

                        <h4 className='cost'><strong>Cost: </strong>₹6,000 - ₹11,000</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Pro%20Package%20for%20Portfolio%20Design'
                            className='btn2'>
                            Contact for OFFERS
                        </a>
                    </div>
                </div>
            </div>

        </div>
    )
}
